import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api } from "../lib/api";

const d = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT") : "—");

export const MediaRetentionClientCard = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/me/media-retention").then((r) => setData(r.data)).catch(() => {});
  }, []);
  const c = data?.case;
  if (!c || c.status === "cancelled") return null;
  const base = process.env.REACT_APP_BACKEND_URL;
  return (
    <section className="rounded-xl border bg-white p-5 space-y-3" data-testid="client-media-retention-card">
      <h3 className="font-semibold">I tuoi media su Dropbox</h3>
      {c.status === "done" ? (
        <p className="text-sm" data-testid="client-mr-deleted">I media del salone sono stati cancellati il {d(c.deleted_at)}.</p>
      ) : (
        <p className="text-sm" data-testid="client-mr-due">
          Il piano Pro è cessato il {d(c.ceased_at)}. I media verranno cancellati dal {d(c.due_at)}
          {c.hold ? ` (cancellazione sospesa fino al ${d(c.hold.until)})` : ""}. Puoi scaricarli prima di quella data.
        </p>
      )}
      <p className="text-xs text-neutral-500">{data.backup_note}</p>
      {data.files.length > 0 && (
        <ul className="max-h-48 overflow-y-auto text-sm divide-y" data-testid="client-mr-files">
          {data.files.map((f) => (
            <li key={f.url} className="flex items-center justify-between py-1">
              <span className="truncate">{f.name}</span>
              <a href={`${base}${f.url}`} className="inline-flex items-center gap-1 text-xs underline" data-testid="client-mr-download">
                <Download className="h-3 w-3" /> Scarica
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
